@if (alertInfo.show) {
  <ngb-alert
    [type]="alertInfo.type"
    (closed)="alertInfo.show = false"
    >
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getCampaignNameInput()"
        label="Name"
        placeholder="Name"
        />
    </div>
    <div class="col-sm-2 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getCampaignDiscountPercentageInput()"
        label="Discount %"
        placeholder="Discount"
        suffix="%"
        />
    </div>
    <div class="col-sm-2 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getCampaignCodeInput()"
        label="Code"
        placeholder="Code"
        />
    </div>
    <div class="col-sm-2 mt-2">
      <input-field
        type="date"
        [inputFormControl]="getCampaignValidFromInput()"
        label="Valid From"
        placeholder="Valid From"
        />
    </div>
    <div class="col-sm-2 mt-2">
      <input-field
        type="date"
        [inputFormControl]="getCampaignValidToInput()"
        label="Valid To"
        placeholder="Valid To"
        />
    </div>
  </div>

  <div class="text-center mt-4">
    <button
      type="button"
      class="btn btn-primary me-4 px-4 py-2"
      (click)="goBack()"
      >
      Back
    </button>
    <button
      type="button"
      class="btn btn-success px-4 py-2"
      (click)="submitForm()"
      >
      Save
    </button>
  </div>
</form>
